// extracted by mini-css-extract-plugin
export default {"root":"ImageTwoLines_root__mqf3A","content":"ImageTwoLines_content__8FtlA","image":"ImageTwoLines_image__qS1ge"};